// extracted by mini-css-extract-plugin
export default {"backButton":"SubchapterHeader_backButton__Jx13L"};